import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { Onix } from '../../../models/Onix';
import { ProductRelationship } from '../../../models/ProductRelationship';
import { BookService } from './../../../services/book.service';

@Component({
  selector: 'app-related-product-selector',
  templateUrl: './related-product-selector.component.html',
  styleUrls: ['./related-product-selector.component.css'],
  providers: [
    BookService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RelatedProductSelectorComponent),
      multi: true
    }
  ]
})
export class RelatedProductSelectorComponent implements OnInit {
  tipologia: Onix;
  ean13: string;

  @Input() eraseable: boolean;
  @Output() removeNotify: EventEmitter<any> = new EventEmitter<any>();

  constructor(private bookService: BookService) { }

  ngOnInit() { }

  onModelChange(e) {
    this.propagateChange(new ProductRelationship({
      tipologia: this.tipologia,
      ean13: this.ean13
    }))
  }

  eraseMe() {
    this.removeNotify.emit();
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj: ProductRelationship) {
    if (obj) {
      this.tipologia = obj.tipologia;
      this.ean13 = obj.ean13;
    }
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/book/related-product-selector/related-product-selector.component.ts